export const builtWithList = [
  { title: 'Create React App', url: 'https://create-react-app.dev/' },
  // { title: 'React 18', url: 'https://reactjs.org/' },
  // { title: 'Redux Toolkit', url: 'https://redux-toolkit.js.org/' },
  // {
  //   title: 'Redux Persist',
  //   url: 'https://www.npmjs.com/package/redux-persist',
  // },
  // { title: 'JavaScript (ES6+)', url: 'https://www.javascript.com/' },
  // { title: 'TypeScript', url: 'https://www.typescriptlang.org/' },
  // { title: 'Material UI 5', url: 'https://mui.com/' },
  // { title: 'React Router 6', url: 'https://reactrouter.com/' },
  // { title: 'Firebase 9', url: 'https://firebase.google.com/' },
  // { title: 'Moment.js', url: 'https://momentjs.com/' },
  // { title: 'Notistack', url: 'https://notistack.com/' },
  // {
  //   title: 'Emoji Picker React',
  //   url: 'https://www.npmjs.com/package/emoji-picker-react',
  // },
  // { title: 'i18next', url: 'https://www.i18next.com/' },
]
